import { Component } from '@angular/core';
import { AccordionItem } from '../../../shared-components/custom-accordion/custom-accordion.component';

@Component({
	selector: 'app-custom-accordion-showcase',
	templateUrl: './custom-accordion-showcase.component.html',
	styleUrls: ['./custom-accordion-showcase.component.scss'],
	standalone: false,
})
export class CustomAccordionShowcaseComponent {
	public lastEvent: string = 'No interaction yet';
	public singleExpanded: boolean = false;

	public readonly singleOpenItems: AccordionItem[] = this.buildItems(true);
	public readonly multipleOpenItems: AccordionItem[] = this.buildItems(true);
	public readonly noIconsItems: AccordionItem[] = this.buildItems(false);
	public readonly customIconItems: AccordionItem[] = this.buildItems(true);
	public readonly noAccentItems: AccordionItem[] = this.buildItems(false);
	public readonly mixedAccentItems: AccordionItem[] = this.buildItems(false).map((item, index) => ({ ...item, noAccentBorder: index === 1 }));
	public readonly eventItems: AccordionItem[] = this.buildItems(false);

	public readonly richContentItems: AccordionItem[] = [
		{
			title: 'Formatted text',
			content: '<p>Content supports <strong>bold</strong>, <em>italic</em>, <u>underline</u> and <a href="#">links</a>.</p>',
			isExpanded: true,
		},
		{
			title: 'Lists',
			content: '<ul><li>First item</li><li>Second item</li></ul><ol><li>Step one</li><li>Step two</li></ol>',
		},
		{
			title: 'Table',
			content: '<table><thead><tr><th>Name</th><th>Status</th></tr></thead><tbody><tr><td>Invoice 1</td><td>Paid</td></tr></tbody></table>',
		},
		{
			title: 'Sanitized content',
			content: '<p>Scripts and inline styles are stripped.</p><script>alert("xss")</script><p style="color: red">No inline style applied</p>',
		},
	];

	public readonly safeTitleItems: AccordionItem[] = [
		{
			title: 'Plain title',
			safeTitle: '<strong>Rich</strong> <em>title</em> with HTML',
			content: '<p>The header renders the sanitized <code>safeTitle</code> instead of <code>title</code>.</p>',
		},
		{ title: 'Regular title', content: '<p>This item has no safeTitle, so it renders the plain title.</p>' },
	];

	public onItemToggle(event: { item: AccordionItem; isExpanded: boolean }): void {
		this.lastEvent = `itemToggle: "${event.item.title}" ${event.isExpanded ? 'expanded' : 'collapsed'}`;
	}

	public onExpandedChange(isExpanded: boolean): void {
		this.singleExpanded = isExpanded;
		this.lastEvent = `expandedChange: ${isExpanded ? 'expanded' : 'collapsed'}`;
	}

	private buildItems(expandFirst: boolean): AccordionItem[] {
		return ['First section', 'Second section', 'Third section'].map((title, index) => ({
			title,
			content: `<p>Content of the <strong>${title.toLowerCase()}</strong>. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>`,
			isExpanded: expandFirst && index === 0,
		}));
	}
}
